<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>查排名</el-breadcrumb-item>
        <el-breadcrumb-item>数据查询</el-breadcrumb-item>
        <el-breadcrumb-item>专业详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">专业详情</h2>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="专业名称"
          prop="name"
        >
          <el-input
            v-model="query.major_keyword"
            placeholder="输入学院名称"
            @input="fetchList()"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="年份"
          prop="year"
        >
          <el-select
            v-model="query.year"
            placeholder="请选择"
            @input="fetchList(true)"
          >
            <el-option
              v-for="item in filter.years"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">专业列表</p>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            type="index"
            width="70"
            label="序号"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="major_name"
            label="专业名称"
            align="center"
          >
            <template slot-scope="scope">
              ({{scope.row.major_code}}){{scope.row.major_name}}
            </template>
          </el-table-column>
          <el-table-column
            prop="os"
            label="查询人数"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{scope.row.user_count}}人</span>
            </template>
          </el-table-column>
          <el-table-column
            label="更新日期"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ $moment(scope.row.update_time).format("YYYY.MM.DD HH:mm") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="handelGoUserList(scope.row)"
              >学员列表</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { rankmajorlist } from "@/api/rank";

export default {
  components: {},
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
        year: 2024,
      },
      pageTotal: 10,
      results: [],
      filter: {
        years: [ {
            label: "2027年",
            value: 2027,
          },
          {
            label: "2026年",
            value: 2026,
          },
          {
            label: "2025年",
            value: 2025,
          },
          {
            label: "2024年",
            value: 2024,
          },
          {
            label: "2023年",
            value: 2023,
          },]
      }
    };
  },
  created() {
    this.query.college_code = this.$route.params.collegeCode
    this.fetchList();
  },
  methods: {
    // 客户端列表请求
    fetchList() {
      rankmajorlist(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchList();
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    handelGoUserList(row) {
      this.$router.push(`/rank/userlist?collegeCode=${row.college_code}&majorCode=${row.major_code}`)
    }
  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
